import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProductWishList } from "./../../redux/actions/wishListAction";

const CardContainerHook = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [favProd, setFavProd] = useState([]);
  const res = useSelector((state) => state.addToWishListReducer.allWishList);
  const currentUser = useSelector((state) => state.authReducer.currentUser);
  useEffect(() => {
    const get = async () => {
      setLoading(true);
      if (currentUser && currentUser.role) {
        await dispatch(getProductWishList());
      }
      setLoading(false);
    };

    get();
  }, [currentUser, dispatch]);

  useEffect(() => {
    if (loading === false) {
      if (res && res.data) {
        if (res.data.length >= 1) {
          setFavProd(res.data.map((item) => item._id));
        }
      } else setFavProd([]);
    }
  }, [loading, res]);

  return [favProd];
};

export default CardContainerHook;
